export default __webpack_public_path__ + "static/media/fikre.2eba099d.jpg";